import { useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  FormControl,
  TextField,
  InputAdornment,
  IconButton,
  Typography
} from '@material-ui/core'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { uploadProviderDocuments } from '../../api/providers.service'
import { useSelector } from 'react-redux'
import { genBase64 } from '../../common/utils'
import AttachFileIcon from '@material-ui/icons/AttachFile'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  },
  rowTitle: {
    marginRight: 8,
    marginBottom: 4,
    fontWeight: 'bold',
    fontSize: 14
  },
  commentContainer: {
    border: 'solid 1.5px #ff1744',
    backgroundColor: '#efefef',
    borderRadius: '10px',
    margin: '15px 0px',
    padding: '10px'
  }
}))

const MyDoctosForm = (props) => {
  const classes = useStyles()

  const handleClose = props.onClose
  const validFileFormat = props.validFileFormat
  const providerSelected = useSelector((state) => state.provider)
  const doctoName = props.doctoName && props.doctoName !== '' ? props.doctoName : undefined

  const formTitle = 'Subir Documento'

  const [loading, setLoading] = useState(false)
  const [currentDoctoName, setCurrentDoctoName] = useState('')
  const [doctoError, setDoctoError] = useState('')

  const loadFile = async (event) => {
    setDoctoError('')
    setCurrentDoctoName('')
    if (event.target.files.length === 0) return
    setCurrentDoctoName(event.target.files[0].name)
  }

  const uploadDocument = async () => {
    const input = document.getElementById('docto')
    if (input.files.length === 0) {
      setCurrentDoctoName('')
      setDoctoError('No ha seleccionado un archivo')
      return
    }
    const file = input.files[0]
    if (validFileFormat && ![validFileFormat].includes(file.type)) {
      setCurrentDoctoName('')
      setDoctoError(`Solo se permiten archivos ${validFileFormat}`)
      return
    }
    setLoading(true)
    const dataFile = {
      providerId: providerSelected.id,
      documentFileName: doctoName ? `${doctoName}.${file.name.split('.').pop()}` : file.name,
      documentBase64Content: await genBase64(file)
    }
    await uploadProviderDocuments(dataFile).finally(() => {
      setLoading(false)
      handleClose()
    })
  }

  const openFileExplorer = () => {
    document.getElementById('docto').click()
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <h2>{formTitle}</h2>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth disabled error={doctoError !== ''}>
            <TextField
              type="text"
              value={currentDoctoName}
              helperText={doctoError}
              error={doctoError !== ''}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton size="medium" aria-label="toggle password visibility" edge="end">
                      <AttachFileIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              label="Seleccione un archivo"
              onClick={openFileExplorer}
              size="medium"
              variant="outlined"
            />
          </FormControl>
          {doctoError !== '' && (
            <Typography color="secondary" variant="caption">
              {doctoError}
            </Typography>
          )}
          <input
            type="file"
            accept={validFileFormat}
            id="docto"
            name="docto"
            className="d-none"
            onChange={loadFile}
          />
        </Grid>
        <SaveOrCancelButtons onSave={uploadDocument} onCancel={handleClose} loading={loading} />
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default MyDoctosForm
